import PropTypes from 'prop-types';
import React from 'react';
import {findDOMNode} from 'react-dom';
import {FormattedMessage} from 'react-intl';

export const tooltipPositions = {
  topLeft: {pos: 'top', arrow: 'left'},
  topRight: {pos: 'top', arrow: 'right'},
  rightTop: {pos: 'right', arrow: 'top'},
  rightBottom: {pos: 'right', arrow: 'bottom'},
  bottomRight: {pos: 'bottom', arrow: 'right'},
  bottomLeft: {pos: 'bottom', arrow: 'left'},
  leftBottom: {pos: 'left', arrow: 'bottom'},
  leftTop: {pos: 'left', arrow: 'top'},
};

class ToolTip extends React.PureComponent {
  static displayName = 'ToolTip';

  static propTypes = {
    body: PropTypes.node,
    iconOnly: PropTypes.bool,
    iconStyle: PropTypes.object,
    iconClass: PropTypes.string,
    title: PropTypes.string,
    position: PropTypes.object,
    style: PropTypes.object,
    invert: PropTypes.bool,

    topLeft: PropTypes.bool,
    topRight: PropTypes.bool,
    rightTop: PropTypes.bool,
    rightBottom: PropTypes.bool,
    bottomRight: PropTypes.bool,
    bottomLeft: PropTypes.bool,
    leftBottom: PropTypes.bool,
    leftTop: PropTypes.bool,
  };

  static defaultProps = {
    iconOnly: false,
    iconClass: 'bl bl-help',
  };

  state = {
    visible: false,
  };

  componentDidUpdate() {
    // Position tooltip and arrow directly with the dom since it depends on the size of the tooltip which we can only calculate after it renders
    if (this.state.visible && this.refs.tooltip) {
      let node = findDOMNode(this.refs.tooltip);
      let _position = this.props.position;

      if (!_position) {
        let fromProps = Object.keys(tooltipPositions).filter(x => this.props[x]);

        if (fromProps && fromProps.length > 0) {
          _position = tooltipPositions[fromProps[0]];
        }
      }
      _position = _position || tooltipPositions.topLeft;
      let {arrow, pos} = _position;


      if (pos === 'top') {
        node.style.top = '-' + (node.offsetHeight + 5) + 'px';
      } else if ((pos === 'left' || pos === 'right') && arrow === 'bottom') {
        node.style.top = -1 * parseInt(node.offsetHeight) + 40 + 'px';
      }

      if (arrow === 'left') {
        node.style.left = '-11px';
      } else if (arrow === 'right') {
        node.style.right = '-8px';
        node.style.left = 'inherit';
      } else if (arrow === 'top') {
        node.style.top = '-8px';
      }

      if (pos === 'right') {
        node.style.right = -1 * node.offsetWidth - 20 + 'px';
      }
    }
  }

  toggleState = (event) => {
    event.preventDefault();
    this.setState({visible: !this.state.visible});
  };

  close = () => {
    this.setState({visible: false});
  };

  render() {
    let _iconClass = this.props.iconClass;
    let _position = this.props.position;

    if (!_position) {
      let fromProps = Object.keys(tooltipPositions).filter(x => this.props[x]);

      if (fromProps && fromProps.length > 0) {
        _position = tooltipPositions[fromProps[0]];
      }
    }
    _position = _position || tooltipPositions.topLeft;

    let iconStyle = {
      margin: 0,
    };

    if (this.props.invert) {
      iconStyle.color = 'white';
    }

    return <div className='tooltip-wrapper' style={this.props.style}>
      <div onClick={this.toggleState} className='tooltip-clickable'>
        <i className={_iconClass} style={iconStyle} />
        {!this.props.iconOnly ? <span>&nbsp;<span className='underline'><FormattedMessage id="tooltip.why.information.important" /></span></span> : null}
      </div>
      {this.state.visible ? <div className={'popover fade in ' + _position.pos} style={{display: 'block'}} ref='tooltip'>
        <button className='icon-button close-button' onClick={this.close}><i className='bl bl-x' /></button>
        <div className={'arrow arrow-' + _position.arrow} />
        <div className='popover-content'>
          {this.props.title || this.props.body}
        </div>
      </div> : null}
    </div>;
  }
}

export default ToolTip;
